module.exports = __webpack_public_path__ + "img/hestevaeddeloeb.fcc20bb1.jpg";